/* eslint-disable camelcase */
export enum OnlineSearchTypes {
  CLEAR_FILTER = '@onlineSearch/CLEAR_FILTER',
  CHANGE_VALUE = '@onlineSearch/CHANGE_VALUE',
  UPDATE_CURRENT_PAGE = '@onlineSearch/UPDATE_CURRENT_PAGE',
  UPDATE_POSTS_PER_PAGE = '@onlineSearch/UPDATE_POSTS_PER_PAGE',
  UPDATE_STORE_FIELDS = '@onlineSearch/UPDATE_STORE_FIELDS',
  FILTER_ACTIVE = '@onlineSearch/FILTER_ACTIVE',
  STATE_FROM_PANEL = '@onlineSearch/STATE_FROM_PANEL',
  HANDLE_ORDER = '@onlineSearch/HANDLE_ORDER',
}

export interface PublicBodyTypes {
  value: number;
  label: string;
}

export interface SituationTypes {
  value: number;
  label: string;
}

export interface DateRangeTypes {
  from: null | string;
  to: null | string;
}

export interface StatesTypes {
  value: number;
  label: string;
  uf: string;
}

export interface RegionTypes {
  label: string;
  value: string;
}
export interface StatesRegionTypes {
  [key: string]: Array<StatesTypes>;
}

export interface CitiesTypes {
  label: string;
  value: string;
}

export interface ModalitiesTypes {
  label: string;
  value: number;
}

export interface MonitoredPortalsTypes {
  label: string;
  value: number;
  sourceClass: string;
  sourceUrl: string;
}

export interface ActivitiesTypes {
  id: number;
  codigo: string;
  nome: string;
}

export interface FiltersTypes {
  updated: boolean;
  id: string;
  uasg: string;
  publicBodyTypes: Array<PublicBodyTypes>;
  processNumber: string;
  object: string;
  note: string;
  address: string;
  publicBody: string;
  itens: string;
  noticeNumber: string;
  includeDateRange: DateRangeTypes;
  deadlineDateRange: DateRangeTypes;
  states: Array<StatesTypes>;
  region: RegionTypes | null;
  cities: Array<CitiesTypes>;
  modalities: Array<ModalitiesTypes>;
  situation: SituationTypes | null;
  exact_search: boolean;
  national: boolean;
  international: boolean;
  validities: boolean;
  hasNotice: boolean;
  hasMonitored: boolean;
  onlyMatch: boolean;
  monitoredPortals: Array<MonitoredPortalsTypes>;
  activities: Array<ActivitiesTypes>;
  geoType: string;
  radius: number;
}

export interface OnlineSearchData {
  filters: FiltersTypes;
  currentPage: number;
  postsPerPage: number;
  filterActive: {
    id: number;
    name: string;
  };
  state_from_panel: Array<StatesTypes>;
  orderedBy: string;
  orderDirection: 'asc' | 'desc';
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface OnlineSearchState {
  readonly onlineSearch: OnlineSearchData;
  readonly request: RequestState;
}
